// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedExpression.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * CalculatedExpression component
 */
import React from 'react';
import { observer } from 'mobx-react';
import EventsUtils from 'EventUtils';
import FormGroup from 'share/components/controls/Izenda.FormGroup';
import Label from 'share/components/controls/Izenda.Label';
import DropDown from 'share/components/controls/Izenda.DropDown';
import TextArea from 'share/components/controls/Izenda.IconAfterCursorInput';
import Validator from 'share/components/hoc/Izenda.Validator';
import constants from 'logic/data/Izenda.CalculatedFieldConstants';

const ValidatableTextArea = Validator()(TextArea);

@observer
class Expression extends React.Component {
  static displayName = 'Expression';

  /**
   * Handel on change of expression.
   * @param {Object} e
   */
  changeExpression = (e: Object) => {
    this.props.closeExpressionSelection();
    this.props.store.clonedModel.changeExpression(e.target.value);
  };

  /**
   * Handel on expression's blur event.
   * @param {Object} e
   */
  blurExpression = (e: Object) => {
    !this.props.expressionSelectionUI.visible &&
      this.props.validateExpression();
  };

  render() {
    let notifyChange = EventsUtils.notifyChange;
    let {
      localization,
      store: { clonedModel: model },
      type,
      displayExpressionSelection
    } = this.props;
    let disabledExpression =
      type.functionLabel &&
      model.functionName !== constants.FUNCTION_NAME.EXPRESSION;

    return (
      <FormGroup className="u_paddingRight">
        <Label className="col-md-3 text-left u_paddingLeft validation required">
          {localization.getText('COMMON_LABEL_EXPRESSION')}
        </Label>
        <div className="col-md-9 u_noPaddingAll">
          <ValidatableTextArea
            id="expressionInput"
            value={model.expression}
            rows="15"
            className="form-control"
            placeholder={constants.EXPRESSION_EXAMPLE}
            onChange={this.changeExpression}
            onBlur={this.blurExpression}
            validations={constants.EXPRESSION_CONSTRAINT(disabledExpression)}
            onClickIcon={displayExpressionSelection}
            disabled={disabledExpression}
            field="expression"
            ref="expressionInput"
          />
        </div>
      </FormGroup>
    );
  }
}

export default Expression;



// WEBPACK FOOTER //
// ./ui/share/components/controls/calculatedField/Izenda.CalculatedExpression.js